import type { FaireReviewEntity } from "../../entity_types/review";

// Real Softies review, read off the brand's public Faire product-reviews API
// (Ryan, 2026-09-02) — verbatim comment, real reviewer, real shop, real date.
// `review_sof*` prefix keeps these from colliding with another brand's files.
export const review_sofb3: FaireReviewEntity = {
  token: "review_sofb3",
  type: "review",
  brandName: "Softies",
  brandToken: "b_br6ji29u",
  reviewType: "brand",
  reviewerName: "Amanda",
  reviewerLocation: "Plainview, TX",
  stars: 5,
  reviewText: "These are always a best seller no matter which items/set we order. Customers simply have to feel of the quality and they walk right out the door with a set. So comfy on we love Softies. Also sell great as gifts.",
  reviewDate: "Feb 21, 2025",
  purchasedProductTokens: [
    "p_acbbjy66dx",
    "p_apf79u59xn",
    "p_jysdty2vvp",
  ],
  meta: {
    source: "api",
    importedAt: "2026-09-02T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
